export default "__VITE_ASSET__D51ONQ2I__"